import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisitUpdateService {
  private visitUpdatedSource = new Subject<void>();
  private sidebarCountUpdatedSource = new Subject<void>();
  private notificationCountUpdatedSource = new Subject<void>();
  
  visitUpdated$ = this.visitUpdatedSource.asObservable();

  notifyVisitUpdated(): void {
    this.visitUpdatedSource.next();
  }

  sidebarCountUpdated$ = this.sidebarCountUpdatedSource.asObservable();

  notifySidebarCountUpdated(): void {
    this.sidebarCountUpdatedSource.next();
  }

  notificationCountUpdated$ = this.notificationCountUpdatedSource.asObservable();

  notifynotificationCountUpdated(): void {
    this.notificationCountUpdatedSource.next();
  }
}